import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { DateTimeInputWUT } from '../../date-time-input/date-time-input/date-time-input-wut';
export const DextDateTimeInputWUT = (props)=>{
    return /*#__PURE__*/ React.createElement(DateTimeInputWUT, {
        ...props,
        fieldType: FIELD_TYPES.DEXT_DATE_TIME_INPUT
    });
};

//# sourceMappingURL=dext-date-time-input-wut.js.map